<app-lfsa-modal [classModal]="''" [idButton]="'abrirModalEmpleado'" [idClose]="'closeModal'" [idOpen]="'openModal'"
                [innTemplate]="bodyModalEmpleados" [titulo]="'Empleados'">
</app-lfsa-modal>
<ng-template #bodyModalEmpleados>
  <app-lfsa-alerts [class]="'primary'" [listaVacia]="listaVaciaEmpleados" [loading]="loadingEmpleados"
                   [texto]="'No se encontraron datos en el listado de Empleados.'"></app-lfsa-alerts>
  <ag-grid-angular #agGrid (gridReady)="onGridReadyProveedores($event)" *ngIf="!listaVaciaEmpleados"
                   [columnDefs]="columnDefsEmpleados" [frameworkComponents]="frameworkComponentsEmpleados"
                   [pagination]="true"
                   [rowData]="rowDataEmpleados" [rowSelection]="rowSelectionEmpleados"
                   class="ag-theme-alpine" [paginationPageSize]="modulo.agGrid.paginacion"
                   style="width: 100%; height: 400px;">
  </ag-grid-angular>
</ng-template>
